/*
* 权限管理组件
* zxw
* 创建时间：
* 修改时间：2026-08-10
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    theme,
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Upload,
    Modal,
    Space,
    Progress,
} from 'antd';
import {
    PlusOutlined,
    ExportOutlined,
    ImportOutlined,
    LoadingOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    ShowIPModal,
    DateFormat,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './AuthorityEntity';

const MODULENAME = CNF.navItems[4].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[4].ptn;
const MODULENAME_URL = CNF.navItems[4].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh } = props;

    const {
        token: {
            pageSize,

        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.name, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, update]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );


    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '前缀', dataIndex: 'prefix', key: 'prefix', },
        { title: '权限名', dataIndex: 'name', key: 'name', },
        { title: '描述', dataIndex: 'description', key: 'description', },
        { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        {
            title: '', key: 'operation', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, operation, hasOpPerm])
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
        </>
    );
}

const Authority = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [name, setName] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleNameChange = useCallback((e) => {
        setName(e.target.value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            name,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, name]);

    // ---------- 导入相关 ----------
    const [modal, modalContextHolder] = Modal.useModal();
    const [instance, setInstance] = useState(null);


    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    const uploadCheck = useCallback((info) => {
        if (info.size > 10240000) {
            messageApi.error('上传文件超过10M，建议拆分文件！', CNF.messageDuration);
            return false;
        }
        if (!info.name.match(/.xls[x]{0,1}/)) {
            messageApi.error('文件格式不对，只支持 xls 或 xlsx ！', CNF.messageDuration);
            return false;
        }
        setInstance(
            modal.info({
                width: isGTscreenWidth ? 500 : 600,
                title: <Space>文件正在上传<LoadingOutlined /></Space>,
                content: <Progress percent={0} />,
                footer: null,
                icon: null,
                keyboard: false,
                closable: false,
            })
        );
        return true;
    }, [messageApi, modal]);

    /**
     * 更新导入弹框
     * @param {*} modal 
     * @param {*} title 
     * @param {*} data 
     * @param {*} percent 
     * @param {*} status 
     */
    const updateModal = useCallback((modalInstance, title, data, percent, status) => {
        modalInstance.update((prevConfig) => ({
            ...prevConfig,
            title,
            content: (
                <>
                    <Progress percent={percent} style={{ width: '100%' }} />
                    <Row style={{ marginTop: CNF.rowMarginTop }}>
                        <Col span={4}><strong>表格行号</strong></Col>
                        <Col span={12}><strong>权限名</strong></Col>
                        <Col span={8}><strong>操作说明</strong></Col>
                    </Row>
                    <div
                        id='import-modal-id'
                        style={{
                            height: 360,
                            marginTop: CNF.rowMarginTop,
                            overflowY: 'auto',
                        }}
                    >
                        {data.map((item, index) => (
                            <Row style={{ lineHeight: 2 }} key={index}>
                                <Col span={4}>{item.key}</Col>
                                <Col span={12}>{item.name}</Col>
                                <Col span={8} style={{ color: item.msg.includes('成功') ? '#000' : item.msg.includes('已导入') ? 'green' : 'red' }}>
                                    {item.msg}
                                </Col>
                            </Row>
                        ))}
                    </div>
                    {status === 'done' && (
                        <div style={{ marginTop: CNF.rowMarginTop * 2, width: '100%', textAlign: 'right' }}>
                            <Button
                                title='确定'
                                variant='solid'
                                style={{ background: global.THEMECOLOR, color: '#fff', border: 0 }}
                                onClick={() => {
                                    modalInstance.destroy();
                                    refresh();
                                }}
                            >
                                确定
                            </Button>
                        </div>
                    )}
                </>
            ),
        }));
    }, [refresh]);

    /**
     * 获取任务
     * @param {*} modal 
     * @param {*} jobId 
     */
    const getJob = useCallback(
        async (modalInstance, jobId) => {
            instance?.update((prevConfig) => ({
                ...prevConfig,
                title: <Space>{MODULENAME}正在导入<LoadingOutlined /></Space>,
                content: <Progress percent={0} />,
            }));

            const messageData = [];
            let total = 0;          // 总记录数（首次获取后固定）
            let processed = 0;      // 已处理记录数（累加）

            try {
                const response = await fetch(CNF.api + 'authoritys/tasks?job_id=' + jobId, {
                    method: 'GET',
                    headers: AddRequestHeaders(),
                    openWhenHidden: true,
                });
                if (!response.ok) {
                    // 处理错误
                }
                const reader = response.body.getReader();
                const td = new TextDecoder('utf-8');
                let jsonData = null;
                while (true) {
                    const { done, value } = await reader.read();
                    const text = td.decode(value, { stream: true });
                    const jsonMatch = text.match(/data:\s*({.*?})\s*\n/);

                    // 计算进度（避免除零）
                    const percent = total > 0 ? (processed / total) * 100 : 0;
                    const percentFixed = parseFloat(percent.toFixed(CNF.DPL));

                    if (jsonMatch) {
                        jsonData = JSON.parse(jsonMatch[1]);
                    } else {
                        // 无有效数据，继续等待
                        if (done) {
                            // 更新进度
                            updateModal(
                                modalInstance,
                                `${MODULENAME}导入结束！`,
                                messageData,
                                percentFixed,
                                'done'
                            );
                            break
                        };
                        continue;
                    }

                    // 若服务端返回错误，直接终止
                    if (jsonData.res !== 0) {
                        modalInstance.destroy();
                        messageApi.error(jsonData.msg, CNF.messageDuration);
                        break;
                    }

                    // 首次获取 total，之后固定
                    if (total === 0 && jsonData.total) {
                        total = jsonData.total;
                    }

                    // 累加本批次记录数
                    const batchData = jsonData.data || [];
                    if (batchData.length) {
                        messageData.push(...batchData);
                        processed += batchData.length;
                    }

                    // 判断是否完成（服务端标识完成 或 已处理数达到总数）
                    const isFinished = jsonData?.id === jsonData?.total || processed >= total;

                    if (done || isFinished) {
                        // 完成时强制 100%
                        updateModal(
                            modalInstance,
                            isFinished ? `${MODULENAME}导入完成！` : `${MODULENAME}导入结束！`,
                            messageData,
                            100,
                            'done'
                        );
                        break;
                    } else {
                        // 更新进度
                        updateModal(
                            modalInstance,
                            <Space>{MODULENAME}正在导入<LoadingOutlined /></Space>,
                            messageData,
                            percentFixed,
                            'running'
                        );
                    }

                    // 滚动至底部
                    const div = document.getElementById('import-modal-id');
                    if (div) {
                        div.scrollTop = div.scrollHeight;
                        div.style.scrollBehavior = 'smooth';
                        div.scrollTo(0, div.scrollHeight);
                    }
                }
            } catch (e) {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    closable: true,
                    onCancel: () => refresh(),
                }));
                messageApi.error('网络错误 !', CNF.messageDuration);
            }
        },
        [instance, messageApi, updateModal, refresh]
    );

    /**
     * 执行导入
     * @param {*} info 
     */
    const upload = useCallback(
        (info) => {
            if (info.file.status === 'uploading') {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    content: <Progress percent={parseFloat(info.file.percent).toFixed(CNF.DPL)} />,
                }));
            } else if (info.file.status === 'done') {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    title: '文件上传完成！',
                    content: <Progress percent={100} />,
                }));
                if (info.file.response?.dat) {
                    setTimeout(() => {
                        getJob(instance, info.file.response.dat.job_id);
                    }, 1000);
                } else {
                    instance?.destroy();
                    messageApi.error(info.file.response?.msg || '上传失败', CNF.messageDuration);
                }
            } else if (info.file.status === 'error') {
                instance?.destroy();
                messageApi.error(`${info.file.name} 导入失败！`, CNF.messageDuration);
            }
        },
        [instance, getJob, messageApi]
    );

    // ---------- 导出相关 ----------
    /***
    * 导出 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '权限管理-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '权限明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '前缀',
                    '权限名',
                    '描述',
                    '状态',
                    '创建时间',
                    '创建者'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取明细
     */
    const exportGetData = () => {
        const params = {
            status: status,
            page_size: 65535,
            current_index: 1,
            name,
        }
        $.ajax({
            url: `${CNF.api}authoritys${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['create_username'];
                            delete item['update_time'];
                            d.push(item);
                        }
                        exportAsExcel(d);
                    } else {
                        exportAsExcel([]);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');
    const hasImport = btnLists.includes(MODULENAME_PTN + '_import');
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            {modalContextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    onChange={handleNameChange}
                    placeholder='权限名'
                    value={name}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status || undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
                {hasImport && (
                    <Upload
                        action={CNF.api + 'authoritys/tasks'}
                        headers={AddRequestHeaders(false)}
                        onChange={upload}
                        beforeUpload={uploadCheck}
                        showUploadList={false}
                        name='file'
                        accept='xlsx,xls,cvs'
                    >
                        <Button
                            title={CNF.actionName.IMPORT + MODULENAME}
                            color='primary'
                            variant='solid'
                            icon={<ImportOutlined />}>
                            {CNF.actionName.IMPORT}
                        </Button>
                    </Upload>

                )}
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
            />
        </>
    );
}

export default Authority